export default "__VITE_ASSET__BAUlgNQw__"